var map = {
	"./assets-delpack-stage.addup.network/images/kyte_logo.svg": 598,
	"./assets-edgfms.edgistify.com/images/kyte_logo.svg": 599,
	"./assets-meghrajexpress-stage.addup.network/images/kyte_logo.svg": 600,
	"./assets-smartr.kyte.app/images/kyte_logo.svg": 601,
	"./assets-stage.addup.network/images/kyte_logo.svg": 270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 376;